import script from "./TouchInformationView.vue?vue&type=script&setup=true&lang=js"
export * from "./TouchInformationView.vue?vue&type=script&setup=true&lang=js"

import "./TouchInformationView.vue?vue&type=style&index=0&id=4d280353&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4d280353"]])

export default __exports__